export default {"src":"/_next/static/media/grayChevron.88b71127.svg","height":9,"width":14,"blurWidth":0,"blurHeight":0};